<template>
  <div id="page-content" tabindex="-1">
    <span aria-label="Data Collection Page" aria-live="polite" role="contentinfo"></span>
    <recaptcha-validation
      role="presentation" 
      ref="recaptcha" 
      @recaptchaValid="onRecaptchaValid"
      @recaptchaInvalid="onRecaptchaInvalid"
      >
    </recaptcha-validation>
    <h2 class="public-h5 font-weight-bold mt-5 mb-5" 
    :class="isRTLLanguage ? 'rtl' : 'normal'">
      {{ pageInfo.header }}
    </h2>
    <p class="text-h8 font-weight-bold"
    :class="isRTLLanguage ? 'rtl' : 'normal'">
      {{ pageInfo.subHeader }}
    </p>
    <p v-html="pageInfo.subHeader2" :class="isRTLLanguage ? 'rtl' : 'normal'"></p>
    <v-card>
      <v-card-text class="centerContainer">
         <div 
            class="red--text" 
            style="font-size:14px" 
            v-if="displayErrorMessage"
            role="alert"
         :class="isRTLLanguage ? 'rtl' : 'normal'">{{ errorMessage }}
        </div>
         <p></p>
         <v-text-field
            v-model="email"
            :label="siteText.ui.emailAddress"
            :class="{'v-text-field--reverse': isRTLLanguage }"
            id="emailTextField"
            ref="emailTextField"
            filled
            dense
            required
            :rules="[isValidEmail]"
          ></v-text-field>
          <!-- <v-text-field
            v-model="emailConfirm"
            :label="siteText.ui.emailAddressConfirm"
            filled
            dense
            required
           ></v-text-field> -->
          <v-text-field
            v-model="phone"
            type="text"
            :label="siteText.ui.phoneNumber"
            :class="{'v-text-field--reverse': isRTLLanguage }"
            id="phoneTextField"
            filled
            dense
            required
            maxlength="14"
            :rules="[isValidPhone]"
            @keypress="isNumber($event)"
            @input="formatPhoneNumber"
          ></v-text-field>
          <v-text-field
            v-model="confirmationNumber"
            :label="siteText.ui.confirmationNumber"
            :class="{'v-text-field--reverse': isRTLLanguage }"
            id="confirmNumberTextField"
            filled
            dense
            required
            @keypress="isNumber($event)"
            maxlength="9"
          ></v-text-field>
      </v-card-text>
    </v-card>
    <p></p>
    <div class="text-left pt-md-4">
      <!-- Desktop Layout -->
      <v-layout row wrap class="hidden-sm-and-down">
      <v-flex md3>
      <v-btn
        class="ma-2 dmv-btn"
        height="45px"
        width="260px"
        @click="back()"
        ><v-icon>mdi-arrow-left</v-icon>
        {{ siteText.ui.dataCollectionBack }}
      </v-btn>
      </v-flex>
      <v-flex md3>
      <v-btn
        class="ma-2 dmv-btn"
        height="45px"
        width="260px"
        :disabled="!validEmail || !validPhone"
        :aria-disabled="!validEmail || !validPhone"
        @click="submit()"
      >
        {{ siteText.ui.dataCollectionSubmit }}
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
      </v-flex>
      </v-layout>
      <!-- mobile Layout -->
      <v-layout row wrap class="hidden-md-and-up">
        <v-flex xs12>
          <v-btn
          class="ma-2 dmv-btn"
          height="45px"
          width="260px"
          :disabled="!validEmail || !validPhone"
          :aria-disabled="!validEmail || !validPhone"
          @click="submit()"
        >
          {{ siteText.ui.dataCollectionSubmit }}
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
        </v-flex>
        <v-flex xs12>
          <v-btn
          class="ma-2 dmv-btn"
          height="45px"
          width="260px"
          @click="back()"
          ><v-icon>mdi-arrow-left</v-icon>
          {{ siteText.ui.dataCollectionBack }}
        </v-btn>
        </v-flex>
        </v-layout>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import common from '../Utilities/common';
import RecaptchaValidation from '../components/RecaptchaValidation.vue';

export default {
  name: 'DataColllectionPage',
  components: {
    RecaptchaValidation
  },
  props: {
    pageInfo: {
      // type: Object,
      required: false,
    },
  },
  data: () => ({
    email: '',
    emailConfirm: '',
    phone: '',
    confirmationNumber: '',
    displayErrorMessage: false,
    errorMessage: '',
    validEmail: false,
    validPhone: false,
  }),
  methods: {
    ...mapActions({
      previousPageAction: 'previousPage'
    }),
    ...mapActions(['getExistingBookings']),
    ...mapActions(["getLocaleSpecificServiceTypes"]),
    nextPage(page) {
      this.$emit('navigateTo', page);
    },
    back() {
      this.$emit('navigateTo', 'WelcomePage');
    },
    submit() {
      this.displayErrorMessage = false;
      this.errorMessage = '';
      
      if (!this.email && !this.phone && !this.confirmationNumber) {
        this.displayErrorMessage = true;
        this.errorMessage = this.siteText.errors.enterOneInfoError;
        this.$refs["emailTextField"].focus();
        return;
      }
   
      if (this.phone) {
        console.log(this.phone);
        if (this.phone.length !== 14) {
          this.displayErrorMessage = true;
          this.errorMessage = this.siteText.errors.invalidPhoneNumberError;
          return;
        }
      }

      //Validate Recaptcha//
      let userDetails = this.getUserDetails();
      this.$refs.recaptcha.verifyRecaptcha(userDetails, this.testSiteCode);
    },
    getUserName() {
      if (this.email) {
        return this.email;
      } else if (this.phone) {
        return this.phone;
      } else if (this.confirmationNumber) {
        return this.confirmationNumber;
      }
      return null;
    },
    getUserDetails(){
      return {
        Email: this.email,
        PhoneNumber: common.normalizePhoneNumber(this.phone),
        ConfirmationNumber: this.confirmationNumber
      }
    },
    isValidEmail(value) {
      // if (!value) {
      //   return 'Error: Email address is required.';
      // }
      // eslint-disable-next-line no-useless-escape
      const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+")){2,}@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (value && !regex.test(value)) {
        this.validEmail = false;
        return this.siteText.errors.invalidFormatEmailError;
      }
      this.validEmail = true;
      return true;
    },
    isValidPhone(value) {
      if (value && value.length !== 14) {
        this.validPhone = false;
        return this.siteText.errors.invalidPhoneNumberError;
      }
      this.validPhone = true;
      return true;
    },
    isNumber(e) {
      if (e.keyCode >= 48 && e.keyCode <= 57) {
        // Number
        return true;
      }
      return e.preventDefault();
    },
    isAlphanumeric(e) {
      if (e.keyCode >= 48 && e.keyCode <= 57) {
        // Number
        return true;
      }
      if ((e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 97 && e.keyCode <= 122)) {
        // Alphabet
        return true;
      }
      return e.preventDefault();
    },
    formatPhoneNumber() {
      const x = this.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      // eslint-disable-next-line prefer-template
      this.phone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    },
    async onRecaptchaValid() {
      //Get Appointment Details//
      //Return true|false to indicate if bookings were found//      
      const phone = common.normalizePhoneNumber(this.phone);
      const bookingsFound = await this.getExistingBookings({email: this.email, phone: phone, confirmationNumber: this.confirmationNumber});
      if(!bookingsFound) {
        console.log("no bookings found");
        this.errorMessage = this.siteText.errors.noReservationFoundError;
        this.displayErrorMessage = true;
        if (this.email) {
          document.getElementById("emailTextField").focus();
        } else if (this.phone) {
          document.getElementById("phoneTextField").focus();
        } else if (this.confirmationNumber) {
          document.getElementById("confirmNumberTextField").focus();
        }
        return;
      }
      await this.getLanguageSpecificServiceTypes();
      console.log(this.reservationOption);
      if (this.reservationOption === 'view') {
        this.$emit('navigateTo', 'ViewReservationPage', { 
          pageName:'View Reservation Details'
      });
      } else if (this.reservationOption === 'cancel') {
        this.previousPageAction({ value: 'DataColllectionPage' });
        this.$emit('navigateTo', 'CancelReservationPage', { 
          pageName:'Cancel Reservation'
      });
      } else if (this.reservationOption === 'reschedule') {
        this.previousPageAction({ value: 'DataColllectionPage' });
        this.$emit('navigateTo', 'RescheduleReservationPage', { 
          pageName:'Current Reservation'
      });
      }
    },
    onRecaptchaInvalid() {
      this.errorMessage = this.siteText.errors.recaptchaError,
      this.displayErrorMessage = true;
    },
    async getLanguageSpecificServiceTypes() {
      if (this.language.Code !== "en") {
        await this.getLocaleSpecificServiceTypes();
      }
    },
  },
  computed: {
    ...mapGetters(['siteText']),
    ...mapGetters(['reservationOption']),
    ...mapGetters(['bookings']),
    ...mapGetters(['testSiteCode']),
    ...mapGetters(['isRTLLanguage','language']),
    displayRTL(){
      return this.isRTLLanguage ? 'direction:rtl !important' : '';
    }
  },
  mounted() {
    console.log(this.bookings);
    if (this.bookings.length > 0) {
      this.email = this.bookings[0].Email;
      this.phone = this.bookings[0].CellPhone;
      this.confirmationNumber = this.bookings[0].ConfirmationNumber;
      if (this.phone && this.phone !== '') {
        this.phone = this.phone.replace(')',') ');
      }
      console.log(this.phone);
    }
  },
};
</script>
<style scoped>
.centerContainer {
  margin: auto;
  width: 95%;
}

.rtl {
  direction: rtl !important;
}

.normal {
  direction: initial !important;
}
</style>
